// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__30kXe","validationTips":"StatementDescriptor_validationTips__1MOXq"};